(ns ui.components.radio-group.view
  (:require
   [frontend.ui.component.icon.view :refer [icon]]
   [ui.components.radix-ui.tooltip.view :as tooltip]
   [ui.util :as uu]))

(defn label-v2
  "HTML label that encapsulates its children.

  See `checkbox/view` for an example usage."
  [{:keys [disabled?] :as props} & children]
  (into
   [:label {:class (uu/cm "w-auto inline-flex gap-2 cursor-pointer group
                           text-base-light-text"
                          (when disabled? "text-disabled-regular-text"))}]
   children))

(defn radio-group-v2
  "Group of radio values.
  `name` is compulsory: it allows grouping these values."
  [{:keys [name on-change checked orientation class]
    :or   {orientation :vertical}
    :as   props} values]
  (into
   [:div
    {:class (uu/cm "inline-flex flex-col gap-3"
                   (when (= orientation :horizontal)
                     "flex-row gap-5")
                   class)}]
   (for [{:keys [value content disabled?]} values]
     (let [checked? (= value checked)]
       [label-v2
        props
        [:input
         {:type      "radio"
          :class     "h-0 w-0
                      absolute opacity-0"
          :name      name
          :disabled  disabled?
          :checked   checked?
          :on-change #(on-change value)}]
        [icon
         {:class   (uu/cm "text-md m-0 mr-1"
                          (when (and checked? (not disabled?))
                            "text-input-gloomy group-hover:text-input-light-text"))
          :variant (if checked? :solid :light)}
         (if checked? :dot-circle :circle)]
        [:<> content]]))))

(defn radio-elem
  [{:keys [disabled? checked? value label on-change class tooltip]}]
  (let [hiccup [:label
                {:class (uu/cm "inline-flex w-auto gap-2 text-[14px] font-semibold cursor-pointer group
                    text-base-light-text-paler"
                               class
                               "flex items-start text-base-light-text justify-start leading-6")}
                [:input
                 {:type      "radio"
                  :class     "h-0 w-0 absolute opacity-0"
                  :disabled  disabled?
                  :checked   checked?
                  :on-change (fn []
                               (on-change value))}]
                [:i
                 {:class (uu/cm (if checked?
                                  "fas fa-dot-circle"
                                  "fal fa-circle")
                                "flex"
                                "text-md m-0 mr-1 mt-1"
                                (when (and checked? (not disabled?))
                                  "text-secondary-gloomy"))}]
                label]]
    (if tooltip
      [tooltip/view
       hiccup
       tooltip]
      hiccup)))

(defn view
  [{:keys [value options on-change horizontal?]}]
  (into [:div
         {:class (if horizontal?
                   "flex flex-row gap-5"
                   "flex flex-col justify-start items-start gap-3")}]
        (for [opt options]
          (let [checked? (= value (:value opt))
                disabled? (boolean (:disabled? opt))]
            [radio-elem
             {:disabled? disabled?
              :checked?  checked?
              :tooltip   (:tooltip opt)
              :value     (:value opt)
              :label     (:label opt)
              :class     (:class opt)
              :on-change on-change}]))))
